import React from "react";

const SquireCheckbox = ({
  id,
  checked,
  label,
  onChange,
  labelStyle = {},
  checkboxStyle = {},
  isCalculator = false,
}) => {
  return (
    <label style={labelStyle} htmlFor={id} className="checkbox-container">
      {label}
      <input
        type="checkbox"
        id={id}
        name={id}
        checked={checked}
        onChange={() => onChange(id)}
        aria-checked={checked}
      />
      <span
        style={checkboxStyle}
        className={`checkbox-label ${
          isCalculator ? "checkbox-label-calculator" : ""
        }`}
      ></span>
    </label>
  );
};

export default SquireCheckbox;
